import { EnumAgreementStatus } from 'api';
const isAgreementApproved = agreement => {
  if (agreement.status === EnumAgreementStatus.Active || agreement.status === EnumAgreementStatus.Inactive || agreement.status === EnumAgreementStatus.ApprovedAwaitingShipping) return true;
  return false;
};
export default isAgreementApproved;